import React from 'react';
import { Segment, Header, Grid } from 'semantic-ui-react';
import { PieChart, Pie, Tooltip, Cell, Legend } from 'recharts';
import { DEFAULT_CHART_COLORS as colors, center, legendStyle } from '../Statistics/util';
import { fetchCurrentAcademicYear, fetchPreviousAcademicYear, fetchStudyCycle } from '../Lookups/util';
import axios from 'axios';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
    cx, cy, midAngle, innerRadius, outerRadius, percent, index
}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} 	dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

const colorsList = ['#2185d0', '#1a6aa6', '#90c2e7', '#e8f2fa'];


export default class StudentServiceHomeStatistic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            currentAcademicYear: '',
            previousAcademicYear: '',

            studyCycles: [],
            graduatedData: [],
            enrolledData: [],

            facultyName: '',

            showChart: false,
            showChart_: false
        };

        this.generateStatisticsData = this.generateStatisticsData.bind(this);
        this.getStudyCycleName = this.getStudyCycleName.bind(this);
        this.getContactInfo = this.getContactInfo.bind(this);
    }

    componentDidMount() {
        axios.all([fetchCurrentAcademicYear(), fetchPreviousAcademicYear(), fetchStudyCycle()])
            .then(axios.spread((currentAcademicYearRes, previousAcademicYearRes, sCyclesRes) => {
                const currentAcademicYear = currentAcademicYearRes.data.id;
                const previousAcademicYear = previousAcademicYearRes.data.id;
                const studyCycles = sCyclesRes.data;

                this.setState({
                    previousAcademicYear, currentAcademicYear, loading: false, studyCycles
                });
                this.generateStatisticsData(currentAcademicYear, previousAcademicYear);
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch academic years');
            });

        this.getContactInfo();
    }

    getContactInfo() {
        axios.get('additional-information/important-contacts')
            .then(res => {
                const resData = res.data;
                this.setState({ facultyName: resData[0].facultyName });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch contact results');
            });
    }

    generateStatisticsData(currentAcademicYear, previousAcademicYear) {
        axios.get(`/statistics/enrolled-per-study-cycle/${currentAcademicYear}`)
            .then(res => {
                const enrolledData = res.data.map(el => ({ name: this.getStudyCycleName(el.studyCycleId), value: el.numberOfStudents }));
                this.setState({ enrolledData, data: enrolledData, showChart_: true });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });


        axios.get(`/statistics/graduated-per-study-cycle/${previousAcademicYear}`)
            .then(res => {
                const graduatedData = res.data.map(el => ({ name: this.getStudyCycleName(el.studyCycleId), value: el.numberOfStudents }));
                this.setState({ graduatedData, showChart: true });
            })
            .catch(err => {
                this.setState({ error: true, });
                console.log('Failed to fetch results');
            });
    }

    getStudyCycleName(id) {
        const { studyCycles } = this.state;
        const selected = studyCycles.find(el => el.id === id);
        if (selected && selected.displayName) return selected.displayName;
        return '';
    }


    render() {
        return (
            <div >
                <Grid columns={2} centered className="stackable">
                    <Grid.Row stretched>
                        <Grid.Column width={8}>

                            <Segment.Group raised >
                                <Segment><h3>Diplomirani studenti u prethodnoj akademskoj godini</h3> </Segment>
                                <Segment> <br /><br /><br /><br /><br />
                                    {this.state.showChart && <Chart data={this.state.graduatedData} /> }
                                    <br /><br /><br /><br /><br />
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment.Group raised >
                                <Segment><h3>Upisani studenti u trenutnu akademsku godinu</h3> </Segment>
                                <Segment><br /><br /><br /><br /><br />
                                    {this.state.showChart_ && <Chart data={this.state.enrolledData} /> }
                                    <br /><br /><br /><br /><br />
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}
class Chart extends React.Component {
    render() {
        return (
            <PieChart style={center} width={450} height={350}>
                <Pie
                    isAnimationActive
                    label={renderCustomizedLabel}
                    labelLine={false}
                    data={this.props.data}
                    cx={150}
                    cy={130}
                    outerRadius={130}
                    innerRadius={20}
                >
                    {
                        this.props.data.map((entry, index) => <Cell fill={colorsList[index % colors.length]} />)
                    }
                </Pie>
                <Legend iconType="circle" iconSize={15} height={20} width={150} layout="vertical" align="left" verticalAlign="bottom" wrapperStyle={legendStyle} />
                <Tooltip />
            </PieChart>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentServiceHomeStatistic.js